const plateAxisOptions = [
  { label: "East-West", value: "X" },
  { label: "North-South", value: "Z" },
  { label: "North-South (Normalized)", value: "Z_NORMALIZED" }
];

export default plateAxisOptions;



// WEBPACK FOOTER //
// ./src/constants/plateAxisOptions.js